import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CellWrapper, CellWithoutDataContent, EllipsisText, CellContent } from './../styles';
import Input from '../StyledMaskedInput';

PercentInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  editable: PropTypes.bool,
  onChange: PropTypes.func,
};
PercentInput.defaultProps = {
  value: '',
  editable: false,
  onChange: null,
};

function PercentInput(props) {
  const { value: propValue, editable: propEditable, onChange, isMissing } = props;
  const [value, setValue] = useState(propValue);
  const [initialValue, setInitialValue] = useState(propValue || '');
  const [editable, setEditable] = useState(!!propEditable);

  useEffect(() => {
    if (propValue !== value && !editable) {
      setValue(propValue);
      setInitialValue(propValue);
      setEditable(false);
    }
    // eslint-disable-next-line
  }, [propValue]);

  const handleChange = (e) => {
    let val = e.target.value.replace(/[^0-9.,]/, '');
    if (val > 100) val = 100;
    setValue(val);
  };

  const handleBlur = (e) => {
    setEditable(false);
    if (onChange && e.target.value !== initialValue) {
      onChange(e.target.value);
    }
  };

  const check = () => {
    setEditable(false);
    console.log('check', editable, value);
    if (onChange) {
      onChange(value);
    }
  };

  const edit = () => {
    setEditable(true);
  };

  return (
    <>
      {editable ? (
        <CellContent>
          <Input
            value={value && parseFloat(value)}
            onChange={handleChange}
            type="text"
            autoFocus
            onBlur={handleBlur}
            onPressEnter={check}
            typeOfMask="percent"
          />
        </CellContent>
      ) : (
        <CellWrapper>
          {value ? (
            <EllipsisText onClick={edit}>
              {`${parseFloat(value).toLocaleString('en-US')}%`}
            </EllipsisText>
          ) : (
            <CellWithoutDataContent onClick={edit} isMissing={isMissing} />
          )}
        </CellWrapper>
      )}
    </>
  );
}


export default PercentInput;
